import React from 'react';
import { CheckCircle2 } from 'lucide-react';
import images from '../data/images.json';
import { content } from '../data/content';

const About = () => {
  return (
    <section id="about" className="py-24 bg-neutral-900">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Title */}
        <div className="text-center mb-20">
          <h2 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-amber-50 mb-6">
            {content.about.title}
          </h2>
          <div className="w-24 h-1 bg-red-600 mx-auto"></div>
        </div>

        {/* Founder Story */}
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center mb-24">
          <div className="relative group">
            <div className="absolute -inset-1 bg-gradient-to-r from-red-600 to-amber-600 rounded-2xl opacity-20 group-hover:opacity-30 blur-xl transition-opacity duration-300"></div>
            <img
              src={images.about.founder}
              alt="Alessandro Di Rienzo con Foody Burger 49"
              className="relative rounded-2xl shadow-2xl w-full h-[500px] object-cover"
            />
          </div>

          <div className="space-y-6">
            <div className="inline-block bg-red-600/10 border border-red-600/20 rounded-lg px-4 py-2">
              <span className="text-red-500 font-semibold">Il Fondatore</span>
            </div>
            
            <h3 className="text-3xl sm:text-4xl font-bold text-amber-50">
              {content.about.founder.name}
            </h3>
            
            <p className="text-xl text-amber-100/80 leading-relaxed">
              {content.about.founder.experience}
            </p>
            
            <p className="text-lg text-amber-100/70 leading-relaxed">
              {content.about.founder.story}
            </p>
            
            <div className="bg-amber-50/5 border border-amber-200/10 rounded-xl p-6">
              <p className="text-amber-100 italic text-lg">
                <span className="text-red-500 font-bold">Missione:</span> {content.about.mission}
              </p>
            </div>
          </div>
        </div>

        {/* Truck Description */}
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          <div className="order-2 lg:order-1 space-y-6">
            <div className="inline-block bg-amber-600/10 border border-amber-600/20 rounded-lg px-4 py-2">
              <span className="text-amber-500 font-semibold">Il Truck</span>
            </div>
            
            <h3 className="text-3xl sm:text-4xl font-bold text-amber-50">
              {content.about.truck.model}
            </h3>
            
            <div className="space-y-3">
              <p className="text-xl text-amber-100/80">
                <span className="font-semibold text-amber-50">Origine:</span> {content.about.truck.origin}
              </p>
              <p className="text-xl text-amber-100/80">
                <span className="font-semibold text-amber-50">Restauro:</span> {content.about.truck.restoration}
              </p>
              <p className="text-xl text-amber-100/80">
                <span className="font-semibold text-amber-50">Stile:</span> {content.about.truck.style}
              </p>
            </div>

            <div className="space-y-4 pt-6">
              {content.about.truck.features.map((feature, index) => (
                <div key={index} className="flex items-start space-x-3">
                  <CheckCircle2 className="w-6 h-6 text-red-500 flex-shrink-0 mt-0.5" />
                  <span className="text-amber-100/80 text-lg">{feature}</span>
                </div>
              ))}
            </div>
          </div>

          <div className="order-1 lg:order-2 relative group">
            <div className="absolute -inset-1 bg-gradient-to-r from-amber-600 to-red-600 rounded-2xl opacity-20 group-hover:opacity-30 blur-xl transition-opacity duration-300"></div>
            <img
              src={images.about.truck}
              alt="Ford F68 1949 - Foody Burger 49"
              className="relative rounded-2xl shadow-2xl w-full h-[500px] object-cover"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
